/* Global Accessibility functionality.
 *
 * Tabbing and skiplinks
 *
 * @file combined
 *
 */

const Accessibility = {
    handleFirstTab: (e) => {
        if (e.keyCode === 9) {
            // the "I am a keyboard user" key
            document.body.classList.add('user-is-tabbing');
            window.removeEventListener('keydown', Accessibility.handleFirstTab);
        }
    },

    init: () => {
        const isIe = /(trident|msie)/i.test(navigator.userAgent);

        if (isIe && document.getElementById && window.addEventListener) {
            window.addEventListener('hashchange', () => {
                const id = location.hash.substring(1);
                if (!/^[A-z0-9_-]+$/.test(id)) {
                    return;
                }

                const element = document.getElementById(id);
                if (element) {
                    if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
                        element.tabIndex = -1;
                    }

                    element.focus();
                }
            }, false);
        }

        window.addEventListener('keydown', Accessibility.handleFirstTab);
    },
};

export default Accessibility;
